import { QueryTable } from "@/components/query-table/QueryTable";
import { EmailTypeSelect } from "@/modules/email-recipients/components/EmailTypeSelect";
import { type ReactNode } from "react";

interface EmailRecipientsToolbarProps {
  emailTypeId?: string;
  onTypeChange: (nextTypeId: string | undefined) => void;
  actions?: ReactNode;
}

export const EmailRecipientsToolbar = ({
  emailTypeId,
  onTypeChange,
  actions,
}: EmailRecipientsToolbarProps) => {
  return (
    <div className="flex flex-row gap-2 justify-between items-center py-2">
      <QueryTable.Menubar className="mb-0 grow">
        <QueryTable.Menubar.Tools />
        <QueryTable.Menubar.Columns />
        <QueryTable.Menubar.Settings />
      </QueryTable.Menubar>
      <div className="flex gap-2">
        <EmailTypeSelect value={emailTypeId} onChange={onTypeChange} />
        {actions}
      </div>
    </div>
  );
};
